module.exports = __webpack_public_path__ + "static/media/watchlist.f0dece44.gif";